module.exports = __webpack_public_path__ + "img/telephone_icon.66ee3380.svg";